import React from "react";
import "./style.scss";
import {lineSpinner} from "ldrs";
import {useSelector} from "react-redux";

lineSpinner.register();

// Reflects how long we have actually been waiting instead of quoting a fixed
// "expected time" - the screen closes as soon as the payment is confirmed.
const getStatusText = (elapsedSeconds) => {
  if (elapsedSeconds < 5) return "Confirming your payment...";
  if (elapsedSeconds < 15) return "Waiting for confirmation from your payment provider...";
  return "This is taking longer than usual, please hold on...";
};

function ProcessingModal({elapsedSeconds = 0}) {
  const {selectedBrand} = useSelector((state) => state.brand);
  return (
    <div className="process_modal_overlay">
      <div className="ProcessingModalWrapper">
        <div className="loaderWithMsg">
          <l-line-spinner
            size="45"
            stroke="3"
            speed="1"
            color={selectedBrand?.brand === "crypto_edge" ? "#fcd535" : "#36d66b"}
          ></l-line-spinner>
          <p className="processingText">Processing...</p>
        </div>
        <p className="processingSubText">{getStatusText(elapsedSeconds)}</p>
        <p className="processingSubText processingElapsed">{elapsedSeconds}s</p>
        <p className="processingSubText">Do not refresh the page</p>
      </div>
    </div>
  );
}

export default ProcessingModal;
